import { useCallback } from "react";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog/dialog";
import { CompleteOperation } from "./complete-operation";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes";

export function CompleteOperationDialog() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOpenChange = useCallback(
    (open: boolean) =>
      void (!open && setTimeout(() => navigate(ROUTES.HOME), 500)),
    [navigate]
  );

  const handleNavigation = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  return (
    <Dialog defaultOpen onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>{t("completeOperation.title")}</DialogTitle>
        </DialogHeader>
        <DialogBody className="bg-header-foreground  flex flex-col min-h-[560px] ">
          <CompleteOperation onSuccess={handleNavigation} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
